<template lang="pug">
form.__parts-form-review(
  method="post"
  :action="$route.fullPath"
  @submit.prevent="submit"
)
  .__parts-form-review__wrap(:class="{morespace: userData}")
    p.__parts-form-review__name(v-if="userData") {{userName}},
    h3.__parts-form-review__header
      slot(name="title") {{ title }}
  .__parts-form-review__wrap(v-show="!userData")
    .__parts-form-review__block
      form-input(
        name="fio"
        v-model="fio"
        :v="$v.fio"
        error-text="Введите Ваше имя"
        placeholder="Ваше имя"
      )
    .__parts-form-review__block
      form-input(
        name="email"
        v-model="email"
        :v="$v.email"
        error-text="Введите правильный email"
        placeholder="Ваш email"
      )
  .__parts-form-review__block
    form-textarea(
      name="text"
      resize="none"
      v-model.trim="text"
      :rows="5"
      :v="$v.text"
      :placeholder="placeholderText"
      :error-text="errorValidationText"
    )
  .__parts-form-review__block(v-if="rating")
    .__parts-form-review__header(:class="{ error: $v.rate.$error }") Оцените программу
    .__parts-form-review__rating
      rating-default(
        @click="rate = $event"
        @hover="hover = $event"
        :value="hover || rate"
        :max="5"
      )
  .__parts-form-review__block.__parts-form-review__error(v-if="error") {{ error }}
  .__parts-form-review__buttons
    button-default(
      color="lime"
      type="submit"
      :rounded="true"
      size="medium"
      @click="submit"
    ) {{buttonText}}
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, email, between } from 'vuelidate/lib/validators';

import ButtonDefault from '@/components/ext/Button.vue';
import RatingDefault from '@/components/parts/rating/default';
import {
  Input as FormInput,
  Textarea as FormTextarea,
} from '@/components/form';

export default {
  mixins: [validationMixin],

  components: {
    FormInput,
    FormTextarea,
    ButtonDefault,
    RatingDefault,
  },

  validations() {
    if (this.rating) {
      return {
        fio: { required },
        text: { required },

        email: {
          required,
          email,
        },

        rate: {
          required,
          between: between(1, 5),
        },
      };
    } else {
      return {
        fio: { required },
        text: { required },

        email: {
          required,
          email,
        },
      };
    }
  },

  props: {
    title: {
      type: String,
      default: '',
    },

    errorValidationText: {
      type: String,
      default: '',
    },

    placeholderText: {
      type: String,
      default: '',
    },

    errorText: {
      type: String,
      default: '',
    },

    localReview: {
      type: Object,
      default: null,
    },

    userData: {
      type: Object,
      default: null,
    },

    rating: {
      type: Boolean,
      default: true,
    },

    buttonText: {
      type: String,
      default: 'Отправить',
    },
  },

  data: () => ({
    fio: '',
    email: '',
    rate: 0,
    hover: 0,
    text: '',
    error: '',
  }),

  computed: {
    userName() {
      const [last, name, secondName] = this.userData.fio.split(' ');
      if (secondName && secondName.length) return `${name} ${secondName}`;
      return `${name} ${last}`;
    },
  },

  watch: {
    errorText(newValue) {
      this.error = newValue;
    },
  },

  beforeMount() {
    if (this.localReview) {
      this.setInputs();
    }
    if (this.userData) {
      this.setUserData();
    }
  },

  methods: {
    submit() {
      const withRate = {
        fio: this.fio,
        email: this.email,
        rate: this.rate,
        text: this.text.replace(/<\/?[^>]+>/gi, ''),
      };
      const withoutRate = {
        fio: this.fio,
        email: this.email,
        text: this.text.replace(/<\/?[^>]+>/gi, ''),
      };
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.rating
          ? this.$emit('submit', withRate)
          : this.$emit('submit', withoutRate);
      }
    },

    setInputs() {
      if (!this.fio) {
        this.fio = this.localReview.fio;
      }
      if (!this.email) {
        this.email = this.localReview.email;
      }
      if (this.localReview.text) {
        this.text = this.localReview.text;
      }
      if (this.localReview.rate) {
        this.rate = this.localReview.rate;
      }
    },

    setUserData() {
      this.fio = this.userData.fio;
      this.email = this.userData.email;
    },
  },
};
</script>

<style lang="scss" scoped>
%text {
  font-size: 20px;
  font-weight: bold;
  text-transform: uppercase;
  color: #333;
  text-align: center;
}

.__parts-form-review {
  &__block {
    margin-bottom: 20px;
  }

  &__name {
    @extend %text;
    margin-bottom: 6px;
  }

  &__header {
    @extend %text;
    margin-bottom: 20px;

    &.error {
      color: red;
    }
  }

  &__rating {
    text-align: center;
  }

  &__buttons {
    text-align: center;
  }

  &__error {
    color: red;
    font-weight: bold;
    font-size: 14px;
    text-align: center;
  }
}

.morespace {
  padding: 51px 0 27px;
}
</style>



// WEBPACK FOOTER //
// Review.vue?3eac8c4e